<template>
  <div class="w-1/3 px-2 pb-4">
    <a href="#" class="template-box" v-on:click.prevent="showTemplateModal(template)">
      <div class="flex items-center justify-between">
        <div class="template-name">
          {{ template.name }}
        </div>

        <a href="#"
          v-on:click.prevent.stop="deleteTemplate(template.id, index)"
          class="delete-template-link">
          <svg width="20" height="20" stroke-width="2" stroke="currentColor" fill="none">
            <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
          </svg>
        </a>
      </div>

      <div class="mt-1 text-sm">
        <span class="text-gray-600">Template Type</span>
        <span class="ml-2 text-gray-900">{{ template.type.charAt(0).toUpperCase() + template.type.slice(1) }}</span>
      </div>

      <div class="mt-4">
        <div class="text-gray-600 mb-1">Includes</div>

        <template v-if="template.type == 'document'">
          <template v-for="(item, index) in template.display">          
            <div v-if="item != null" class="inline-block bg-gray-600 px-2 py-1 mr-1 mb-1 text-xs text-white rounded-sm">{{ item.name }}</div>
          </template>
        </template>

        <template v-else>
          <template v-for="(item, index) in uniqueTypes(template.data)">          
            <div class="inline-block bg-gray-600 px-2 py-1 mr-1 mb-1 text-xs text-white rounded-sm">
              {{ item }} 

              <template v-if="numType(item) > 1">
                x {{ numType(item) }}
              </template>
            </div>
          </template>
        </template>
      </div>

      <div class="mt-3 text-gray-600 text-xs">
        Created - {{ template.created_at.split(" ")[0] }}
      </div>
    </a>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'

  export default {

    components: {
      
    },

    props : {
      template : {
        type    : Object,
        required: true
      },

      index : {
        type    : Number,
        required: true
      },

      showTemplateModal : {
        type    : Function,
        required: true
      },

      deleteTemplate : {
        type    : Function,
        required: true
      }
    },

    methods : {
      uniqueTypes(arr) {
        return _.uniq(arr)
      },

      numType(type) {
        return _.countBy(this.template.data)[type]
      },
    }
  }
</script>

<style scoped>
  .template-box {
    @apply border border-gray-500 bg-gray-100 p-3 block rounded-sm cursor-pointer;
  }

  .template-box:hover {
    @apply bg-gray-200;
  }

  .template-name {
    @apply text-base;
  }

  .template-box:hover a.template-name {
    @apply underline;
  }

  .template-box a.delete-template-link {
    @apply invisible;
  }

  .template-box:hover a.delete-template-link {
    @apply visible;
  }

  a.delete-template-link {
    @apply text-gray-500;
  }

  a.delete-template-link:hover {
    @apply text-gray-700;
  }
</style>